import React, { useState } from 'react';
import './Attendance.css';
import Header from "../../components/common/Header";
import { IoFingerPrint } from "react-icons/io5";
import { FiSearch } from "react-icons/fi";

const defaultLogsByEmployee = {
  "Arun Kumar": [
    { date: "Oct 01", checkIn: "09:00 AM", checkOut: "06:00 PM", workingHours: "9 hrs", status: "Present" },
    { date: "Oct 02", checkIn: "09:15 AM", checkOut: "06:00 PM", workingHours: "8 hrs 45 mins", status: "Present" },
    { date: "Oct 03", checkIn: "09:10 AM", checkOut: "06:10 PM", workingHours: "9 hrs", status: "Present" },
    { date: "Oct 04", checkIn: "—", checkOut: "—", workingHours: "—", status: "Sunday" },
    { date: "Oct 05", checkIn: "—", checkOut: "—", workingHours: "—", status: "Leave" },
    { date: "Oct 06", checkIn: "09:05 AM", checkOut: "06:10 PM", workingHours: "9 hrs 05 mins", status: "Present" },
    { date: "Oct 07", checkIn: "09:00 AM", checkOut: "06:00 PM", workingHours: "9 hrs", status: "Present" },
  ],
  "Vijay": [
    { date: "Oct 01", checkIn: "09:15 AM", checkOut: "06:00 PM", workingHours: "8 hrs 45 mins", status: "Present" },
    { date: "Oct 02", checkIn: "09:15 AM", checkOut: "06:00 PM", workingHours: "8 hrs 45 mins", status: "Present" },
    { date: "Oct 03", checkIn: "09:10 AM", checkOut: "06:10 PM", workingHours: "9 hrs", status: "Present" },
    { date: "Oct 04", checkIn: "—", checkOut: "—", workingHours: "—", status: "Sunday" },
    { date: "Oct 05", checkIn: "—", checkOut: "—", workingHours: "—", status: "Leave" },
    { date: "Oct 06", checkIn: "09:15 AM", checkOut: "06:00 PM", workingHours: "8 hrs 45 mins", status: "Present" },
    { date: "Oct 07", checkIn: "09:10 AM", checkOut: "06:00 PM", workingHours: "8 hrs 50 mins", status: "Present" },
  ],
  "Kumar": [
    { date: "Oct 01", checkIn: "09:00 AM", checkOut: "06:00 PM", workingHours: "9 hrs", status: "Present" },
    { date: "Oct 02", checkIn: "09:15 AM", checkOut: "06:00 PM", workingHours: "8 hrs 45 mins", status: "Present" },
    { date: "Oct 03", checkIn: "09:10 AM", checkOut: "06:10 PM", workingHours: "9 hrs", status: "Present" },
    { date: "Oct 04", checkIn: "—", checkOut: "—", workingHours: "—", status: "Sunday" },
    { date: "Oct 05", checkIn: "—", checkOut: "—", workingHours: "—", status: "Leave" },
  ],
};

const defaultLogs = [
  { date: "Oct 01", checkIn: "09:00 AM", checkOut: "06:00 PM", workingHours: "9 hrs", status: "Present" },
  { date: "Oct 02", checkIn: "09:15 AM", checkOut: "06:00 PM", workingHours: "8 hrs 45 mins", status: "Present" },
  { date: "Oct 03", checkIn: "09:10 AM", checkOut: "06:10 PM", workingHours: "9 hrs", status: "Present" },
  { date: "Oct 04", checkIn: "—", checkOut: "—", workingHours: "—", status: "Sunday" },
  { date: "Oct 05", checkIn: "—", checkOut: "—", workingHours: "—", status: "Leave" },
  { date: "Oct 06", checkIn: "09:05 AM", checkOut: "06:10 PM", workingHours: "9 hrs 05 mins", status: "Present" },
  { date: "Oct 07", checkIn: "09:00 AM", checkOut: "06:00 PM", workingHours: "9 hrs", status: "Present" },
];

const BiometricDetail = ({ employee, onClose }) => {
  const employeeName = employee?.employeeName || "Employee";
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7;

  const rawLogs = defaultLogsByEmployee[employeeName] || defaultLogs;

  const filteredLogs = rawLogs.filter((item) => {
    const term = searchTerm.toLowerCase();
    return (
      item.date.toLowerCase().includes(term) ||
      item.status.toLowerCase().includes(term) ||
      item.workingHours.toLowerCase().includes(term)
    );
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentLogs = filteredLogs.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.max(1, Math.ceil(filteredLogs.length / itemsPerPage));
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const getStatusColor = (status) => {
    switch (status) {
      case 'Present':
        return '#16a34a';
      case 'Sunday':
        return '#2563eb';
      case 'Leave':
        return '#d97706';
      case 'Absent':
        return '#dc2626';
      default:
        return '#4b5563';
    }
  };

  return (
    <div>
      <Header
        title="Biometric Attendance"
        subtitle={`Employee biometric log - ${employeeName}`}
        showBack={true}
        onBack={onClose}
      />

      <div className='table-container'>
        <div className='table-controls'>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
            {/* Search Box */}
            <div className="search-wrapper">
              <FiSearch className="search-icon" />
              <input
                type='text'
                className='search-input-with-icon'
                placeholder='Search Date / Status'
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>

            {/* Employee Badge */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginTop: 19,
                height: '37px',
                padding: '0 16px',
                backgroundColor: '#ffffff',
                border: '1px solid #ddd',
                borderRadius: '12px',
                color: '#000000',
                fontWeight: 600,
                fontSize: '13px',
              }}
            >
              <IoFingerPrint size={18} color="#000000" />
              <span>{employeeName}</span>
            </div>
          </div>

          <div className='button-container'>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginTop: 19,
                height: '37px',
                padding: '0 16px',
                backgroundColor: '#ffffff',
                border: '1px solid #ddd',
                borderRadius: '12px',
                fontSize: '13px',
                color: '#333333',
              }}
            >
              <span>Month:</span>
              <span style={{ color: '#000000', fontWeight: 600 }}>October 2026</span>
            </div>
          </div>
        </div>

        <table className='table'>
          <thead>
            <tr>
              <th className='th'>Date</th>
              <th className='th'>Check In</th>
              <th className='th'>Check Out</th>
              <th className='th'>Working Hours</th>
              <th className='th'>Status</th>
            </tr>
          </thead>
          <tbody>
            {currentLogs.length > 0 ? (
              currentLogs.map((item, idx) => (
                <tr key={idx}>
                  <td className='td'>{item.date}</td>
                  <td className='td'>{item.checkIn}</td>
                  <td className='td'>{item.checkOut}</td>
                  <td className='td'>{item.workingHours}</td>
                  <td className='td'>
                    <span
                      style={{
                        color: getStatusColor(item.status),
                        fontWeight: 500,
                      }}
                    >
                      {item.status}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className='td' style={{ textAlign: 'center', padding: '24px' }}>
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <div className='table-footer'>
          <div className='record-count'>
            Showing {filteredLogs.length === 0 ? 0 : indexOfFirstItem + 1} to{" "}
            {Math.min(indexOfLastItem, filteredLogs.length)} of{" "}
            {filteredLogs.length} entries
          </div>

          <div className='pagination'>
            <button
              className='pagination-button'
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
            >
              &lt;
            </button>
            {pageNumbers.map((num) => (
              <button
                key={num}
                className={`pagination-button ${currentPage === num ? "active" : ""}`}
                onClick={() => setCurrentPage(num)}
              >
                {num}
              </button>
            ))}
            <button
              className='pagination-button'
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
            >
              &gt;
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BiometricDetail;
